
import TruckTick from "../../../assets/duotone/TruckTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TruckTickIcon({ className, dataTestid = "TruckTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TruckTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
